import { render, staticRenderFns } from "./BackDialogComponent.vue?vue&type=template&id=606ce561&scoped=true"
import script from "./BackDialogComponent.vue?vue&type=script&lang=js"
export * from "./BackDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606ce561",
  null
  
)

export default component.exports